module.exports = __webpack_public_path__ + "img/unstakeTokens.2484f103.svg";